import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_fixed_asset_register_depreciation_config_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  depr_start: fromDatatype.TimestampTzDatatypeInterface;
  depr_method: fromDatatype.VarcharDatatypeInterface;
  residual_value: fromDatatype.NumericDatatypeInterface;
  depr_ave_method: fromDatatype.VarcharDatatypeInterface;
  depr_rate: fromDatatype.NumericDatatypeInterface;
  useful_life: fromDatatype.NumericDatatypeInterface;
  fi_acc_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
  fi_acc_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
  fi_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
  fi_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_fixed_asset_register_depreciation_config_RowClass implements bl_fi_fixed_asset_register_depreciation_config_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  depr_start: fromDatatype.TimestampTzDatatypeInterface;
  depr_method: fromDatatype.VarcharDatatypeInterface;
  residual_value: fromDatatype.NumericDatatypeInterface;
  depr_ave_method: fromDatatype.VarcharDatatypeInterface;
  depr_rate: fromDatatype.NumericDatatypeInterface;
  useful_life: fromDatatype.NumericDatatypeInterface;
  fi_acc_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
  fi_acc_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
  fi_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
  fi_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
